<template>
  <div class="legal-page">
    <HeadNav selectedLanguage="en" :page="page" :gotodownload="gotodownload" :apk="apk" />
    <main class="legal-content">
      <slot />
    </main>
  </div>
</template>

<script>
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'LegalPage',
  components: {
    HeadNav
  },
  props: {
    page: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      apk: null
    };
  },
  methods: {
    gotodownload() {}
  }
};
</script>

<style>
.legal-page {
  min-height: 100vh;
  background: #f6f8fb;
  padding-bottom: 30px;
}

.legal-page .legal-content {
  max-width: 900px;
  margin: 40px auto 0;
  padding: 48px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(24, 39, 75, 0.08);
  color: #374151;
  line-height: 1.8;
}

.legal-page .legal-content h1 {
  margin: 0;
  color: #111827;
  font-size: 2.6rem;
  line-height: 1.2;
  text-align: center;
}

.legal-page .legal-content h2 {
  margin: 0 0 14px;
  color: #1f2937;
  font-size: 30px !important;
  line-height: 1.35;
  font-weight: 500;
}

.legal-page .legal-content section {
  margin-top: 34px;
}

.legal-page .legal-content p {
  margin: 0 0 16px;
}

.legal-page .legal-content p:last-child {
  margin-bottom: 0;
}

.legal-page .legal-content ul {
  margin: 12px 0 0;
  padding-left: 24px;
}

.legal-page .legal-content li {
  margin-bottom: 12px;
}

.legal-page .legal-content a {
  color: #2563eb;
  text-decoration: none;
}

.legal-page .legal-content a:hover {
  text-decoration: underline;
}

.legal-page .last-updated {
  margin: 14px 0 42px;
  color: #6b7280;
  text-align: center;
  font-weight: 600;
}

.legal-page .intro {
  margin: 22px 0 42px;
  color: #4b5563;
  font-size: 1.08rem;
  text-align: center;
}

.legal-page .contact-card {
  padding: 30px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}

@media (max-width: 768px) {
  .legal-page .legal-content {
    margin: 20px 12px 0;
    padding: 28px 20px;
    border-radius: 12px;
  }

  .legal-page .legal-content h1 {
    font-size: 2rem;
  }

  .legal-page .legal-content h2 {
    font-size: 28px;
  }
}
</style>
